<template>
    <div style="width:100vw;height:100vh;opacity: 0;display:none;transition: opacity 1s;user-select: none;">
        <icon-close style="width:25px; right:10vw;top:10vw;position: absolute;z-index: 9999; cursor: pointer"
                    v-on:click.native="hide"/>
        <!--		<icon-menu style="width:25px; right:5vw;top:30%;position: absolute;z-index: 9999"/>-->
        <div style="position: absolute;left:0px;top:0px;width:100vw;height:100vh;background-color: black;opacity:.85;z-index: 10">
        </div>
        <div CLASS="center-align"
             style="position: absolute;left:0px;top:0px;width:100vw;height:100vh;z-index: 20;font-size:4vh;font-family: big-caslon-fb;letter-spacing: .1em; text-align: center;line-height: 1.5;">

            <router-link to="/" exact-active-class="active">HOME</router-link>
            <!--			<router-link to="/news" active-class="active">NEWS</router-link>-->
            <router-link to="/collections" active-class="active">COLLECTIONS</router-link>
            <router-link to="/team" active-class="active">TEAM</router-link>
            <router-link to="/contact" active-class="active">CONTACT</router-link>

        </div>
    </div>

</template>

<script>
	import IconClose from "@/components/IconClose";
	import IconMenu from "@/components/IconMenu";

	export default {
		name: 'MainMenu',
		props: {},
		components: {
			IconClose
		},
		data() {
			return {}
		},
		methods: {
			show() {
				let style = this.$el.style;
				style.display = "block";
				style.opacity = "0";

				setTimeout(() => {
					style.opacity = "1"
				}, 1);
			},
			hide() {
				let style = this.$el.style;
				style.display = 'block';
				style.opacity = "0";
				setTimeout(() => {
					style.display = "none"
				}, 1000);
			}
		},
		mounted() {
		}

	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    a {
        display: block;
        color: white;
        text-decoration: none;
        cursor: pointer;
    }

    a:hover {
        color: #c4c090;
    }

    .active {
        color: #c4c090;
    }

    .center-align {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
    }
</style>
